import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Layout from '@/components/layout'
import report from '@/components/report'
import grade from '@/components/grade'
import month from '@/components/month'
import eventChange from '@/components/eventChange'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' // Progress 进度条样式
import print6 from '../components/po/poreview/print6.vue'
import print6_2 from '../components/po/poreview/print6_2.vue'
import print9 from '../components/po/poreview/print9.vue'
import print9_2 from '../components/po/poreview/print9_2.vue'
import hwprint from '../components/po/hwreview/hwprint.vue'
import hwprint_2 from '../components/po/hwreview/hwprint_2.vue'
import stickerPrint from '../components/po/exam/stickerPrint.vue'
import pickCard from '../components/po/exam/pickCard.vue'
import pickCard2 from '../components/po/exam/pickCard2.vue'

// const _import = require('./_import_' + process.env.NODE_ENV);
const _import = require('./_import_production');
// console.log(process.env.NODE_ENV);

Vue.use(VueRouter)

const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
    return VueRouterReplace.call(this, to).catch(err => err)
}

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

const routes = [
    { path: '/', redirect: '/index' },
    {
        path: '/password',
        name: 'password',
        component: Layout,
        children: [{
            path: "",
            component: _import("/password"),
            meta: { title: '修改密码', fullPath: '/password', isHide: true }
        }]
    },
    {
        path: '/flow',
        name: 'flow',
        component: Layout,
        children: [{
            path: "",
            component: _import("/flow"),
            meta: { title: '流程设计', fullPath: '/flow', isHide: true }
        }]
    },
    // {
    //   path: '/review',
    //   name: 'review',
    //   component: Layout,
    //   children: [
    //     {
    //       path: "",
    //       component: _import("/review"),
    //       meta: { title: '审核列表', fullPath: '/review', isHide: true }
    //     }
    //   ]
    // },
    {
        path: '/login',
        name: 'login',
        component: _import('/login'),
        meta: {
            noAuth: true
        }
    },
    {
        path: '/auth',
        name: 'auth',
        component: _import('/auth'),
        meta: {
            noAuth: true
        }
    },
    {
        path: '/msg',
        name: 'msg',
        component: _import('/msg'),
        meta: {
            noAuth: true
        }
    },
    {
        path: '/class',
        name: 'class',
        component: report,
    },
    {
        path: '/grade',
        name: 'grade',
        component: grade,
    },
    {
        path: '/gradeMonth',
        name: 'gradeMonth',
        component: month,
    },
    {
        path: '/eventChange',
        name: 'eventChange',
        component: eventChange,
    },
    {
        name: 'print6',
        path: '/print6',
        component: print6,
        meta: {
            noAuth: true
        }
    },
    {
        name: 'print6_2',
        path: '/print6_2',
        component: print6_2,
        meta: {
            noAuth: true
        }
    },
    {
        name: 'print9',
        path: '/print9',
        component: print9,
        meta: {
            noAuth: true
        }
    },
    {
        name: 'print9_2',
        path: '/print9_2',
        component: print9_2,
        meta: {
            noAuth: true
        }
    },
    {
        name: 'hwprint',
        path: '/hwprint',
        component: hwprint,
        meta: {
            noAuth: true
        }
    },
    {
        name: 'hwprint_2',
        path: '/hwprint_2',
        component: hwprint_2,
        meta: {
            noAuth: true
        }
    },
    {
        name: 'pickCard',
        path: '/pickCard',
        component: pickCard,
        meta: {
            noAuth: true
        }
    },
    {
        name: 'pickCard2',
        path: '/pickCard2',
        component: pickCard2,
        meta: {
            noAuth: true
        }
    },
    {
        name: 'stickerPrint',
        path: '/stickerPrint',
        component: stickerPrint,
        meta: {
            noAuth: true
        }
    },
    // {
    //   path: '/qywxAuth/:path?',
    //   name: 'qywxAuth',
    //   component: _import('/qywxAuth'),
    //   props: true,
    //   meta: {
    //     title: '微信企业认证',
    //     noAuth: true
    //   }
    // }
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    // if(to.meta.ColumnName){
    //   let head = document.getElementsByTagName('head');
    //   if(head[0].length-1) {
    //     head[0].removeChild([head[0].length-1])
    //   }
    //   let meta = document.createElement('meta');
    //   meta.content = to.meta.ColumnName;
    //   head[0].appendChild(meta)
    //  }
    // if (to.meta.isFrontColumn) {
    //   window.scrollTo(0, 0);
    // }
    NProgress.start()
    if (to.meta && to.meta.noAuth) {
        next()
    } else {
        if ((from.meta.noAuth || to.meta.noAuth) && from.path !== '/login') {
            next('/')
            NProgress.done()
            return
        }
        /* 判断是否有已登录 */
        if (localStorage.getItem("token") ? true : false) {
            // console.log('有token', to)
            /* 判断是否已读取身份信息 */
            if (store.getters.hasIdentityInfo) {
                next()
            } else {
                /* 获取身份信息 */
                store.dispatch("getIdentityInfo").then(res => {
                    let permissionMenus = res.Menus;
                    let permissionRouters = [];

                    /*先取出顶级菜单，Pid为0的就是顶级菜单*/
                    permissionMenus.forEach((m, i) => {
                        if (m.Pid == 0 && m.MenuType != 1) {
                            let parentMenu = {
                                path: m.FullPath,
                                name: m.Url,
                                component: Layout,
                                meta: { id: m.MenuId, title: m.MenuName, fullPath: m.FullPath, icon: m.Url }
                            }
                            permissionRouters.push(parentMenu)
                        }
                    })

                    function convertTree(routers) {
                        routers.forEach(r => {
                            permissionMenus.forEach((m, i) => {
                                if (m.Pid != 0 && m.Pid == r.meta.id) {
                                    if (!r.children) r.children = []
                                        // let isArticel = m.FullPath == '/articles/webarticle';
                                    let importPath = m.FullPath

                                    //  if(m.MenuName=="学生信息管理") console.log(m)

                                    // m.Url = isArticel ? "webarticle" + m.Meta.ColumnId : m.Url;
                                    // m.FullPath = isArticel ? importPath + m.Meta.ColumnId : m.FullPath;
                                    let menu = {
                                        path: m.Url,
                                        name: m.Url,
                                        component: _import(importPath + "/"),
                                        meta: {
                                            id: m.MenuId,
                                            title: m.MenuName,
                                            fullPath: m.FullPath,
                                            // ColumnId: m.Meta != null ? m.Meta.ColumnId : null,
                                            // ColumnType: m.Meta != null ? m.Meta.ColumnType : null,
                                        }
                                    }
                                    r.children.push(menu)
                                }
                            })
                            if (r.children) {
                                convertTree(r.children)
                            }
                        })
                    }
                    convertTree(permissionRouters)

                    permissionRouters.unshift({
                        path: '/dashboard',
                        name: 'dashboard',
                        component: Layout,
                        meta: { title: '工作台', fullPath: '/dashboard', isDashboard: true, affix: true, icon: 'dashboard_new' },
                        children: [{
                            path: "",
                            component: _import("/index"),
                            meta: { title: '工作台', fullPath: '/dashboard', isHide: true }
                        }]
                    })

                    // console.log(permissionRouters, 'permissionRouters');
                    store.commit('SET_PERMISSION_ROUTERS', permissionRouters);
                    router.addRoutes(permissionRouters);
                    router.addRoutes([{ path: '*', redirect: '/dashboard' }]);
                    // console.log('permissionRouters', to);
                    next({ path: to.path, replace: true, query: to.query });
                })
            }
        } else {
            console.log('无token')
            var ua = window.navigator.userAgent.toLowerCase();
            //iPhone: Mozilla/5.0 (iPhone; CPU iPhone OS 5_1 like Mac OS X) AppleWebKit/534.46 (KHTML, like Gecko) Mobile/9B176 MicroMessenger/4.3.2
            //Android: Mozilla/5.0 (Linux; U; Android 2.3.6; zh-cn; GT-S5660 Build/GINGERBREAD) AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1 MicroMessenger/4.5.255
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                console.log('微信', to.path, from)
                localStorage.setItem('redirectUrl', to.path)
                next('/auth')
                if (from.path == "/auth") {
                    NProgress.done()
                }
            } else {
                next('/login')
                if (from.path == "/login") {
                    NProgress.done()
                }
            }
        }
    }
    // next({ path: to.path, replace: true });
})

router.afterEach((to, from) => {
    NProgress.done()
    if (to.meta && to.meta.title) {
        document.title = to.meta.title + ' | ' + store.state.sys.title
    } else {
        document.title = store.state.sys.title
    }
})

export default router